import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DirectDebitService } from '../../../services/direct-debit/direct-debit.service';

@Component({
  selector: 'app-afiliacion-dnd',
  templateUrl: './dnd.component.html',
  styleUrls: ['./dnd.component.css']
})
export class DndComponent implements OnInit {

  @Output() response = new EventEmitter<any>();
  @Output() reset = new EventEmitter<any>();
  // @Input() loading(_loading: boolean) {
  //   this._loading = _loading;
  // };

  @Input() set direct_debit(_direct_debit: any) {
    this._direct_debit = _direct_debit;
  };

  @Input() set config(config: any) {
    this.config_read = config;
  };

  _loading = false;
  _direct_debit: any;
  config_read: any;
  verified = false;
  error = false;


  constructor(
    private directDebitService: DirectDebitService,
  ) { }

  ngOnInit(): void {
    
  }

  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef | undefined;
  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped(files: File[]) {
   
    this.prepareFilesList(files);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler($event: any) {
    let files = ($event.target as HTMLInputElement).files;
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    if (this.files[index].progress < 100) {
      console.log("Upload in progress.");
      return;
    }
    this.files.splice(index, 1);
    this.verified = false;
    this.reset.emit(true);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
   
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
   
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: any) {
    this.error = false;
    this.verified = false;
    this._loading = true;
    this.files = [];
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    if (this.fileDropEl && this.fileDropEl.nativeElement) {
      this.fileDropEl.nativeElement.value = "";
    }
    this.uploadFilesSimulator(0);
    this.readFileService();
  }

  readFileService = async () => {
    this.verified = false;
    this.error = false;
    try{
      // Comento ya que es dinamico, pero dejo la configuración de mercantil por si se pierde de bd
      // let config_default = '[{"length":256,"tipo":{"length":1,"value":"1"},"attr":[{"name":"TIPOREG","length":1,"deleteZero":true},{"name":"BANKID","length":12,"deleteEmpty":true},{"name":"LOTE","length":15,"deleteEmpty":true},{"name":"TIPOEMPRESA","length":1,"deleteEmpty":true},{"name":"NUMEMPRESA","length":10,"deleteZero":true},{"name":"CODPRODUCTO","length":5,"deleteEmpty":true},{"name":"FECHAENVIO","length":8,"deleteZero":true},{"name":"CANTREGDET","length":10,"deleteZero":true},{"name":"TIPOEMPREL","length":1,"deleteEmpty":true},{"name":"NUMEMPREL","length":10,"deleteZero":true},{"name":"CODRESLOTE","length":3,"deleteEmpty":true},{"name":"MENRESLOTE","length":30,"deleteEmpty":true},{"name":"AREALIBRE","length":150,"deleteEmpty":true}]},{"length":256,"tipo":{"length":1,"value":"2"},"attr":[{"name":"TIPOREG","length":1,"deleteZero":true},{"name":"ACCION","length":1,"deleteEmpty":true},{"name":"TIPOCLIENTE","length":1,"deleteEmpty":true},{"name":"NUMCLIENTE","length":10,"deleteZero":true},{"name":"NOMCLIENTE","length":30,"deleteEmpty":true},{"name":"NUMINSTRUMENTO","length":21,"deleteZero":true},{"name":"IDENCLIEMPR","length":16,"deleteEmpty":true},{"name":"RESERVADO1","length":9,"deleteEmpty":true},{"name":"IDSERVICIO","length":16,"deleteEmpty":true},{"name":"RESERVADO2","length":1,"deleteEmpty":true},{"name":"ORIGREGISTRO","length":1,"deleteEmpty":true},{"name":"RESERVADO3","length":17,"deleteZero":true},{"name":"RESERVADO4","length":17,"deleteZero":true},{"name":"RESERVADO5","length":1,"deleteZero":true},{"name":"CODRESPUESTA","length":3,"deleteZero":true},{"name":"MENRESPUESTA","length":30,"deleteEmpty":true},{"name":"RESERVADO6","length":81,"deleteEmpty":true}]}]';
      let config = this.config_read.config;
      let response = await this.directDebitService.readDirectDebitFile(config, this.files[0]);
      let header = this.getHeader(response.data);
      this._loading = false;
      debugger;
      if(this._direct_debit.lote.padStart(10, '0').toString()===header['LOTE'].padStart(10, '0').toString() && header['MENRESLOTE']==="LOTE PROCESADO") { // aqui tendría que validar el lote
      //if(true) { // aqui tendría que validar el lote
        this.verified = true;
        this.response.emit({response, file: this.files[0]});
      }else {
        this.error = true;
        this.response.emit(null);
      }
    } catch(error) {
      console.log(error);
      this._loading = false;
      this.error = true;
      this.response.emit(null);
      console.log('entra por la via del error');
      console.log(false);
    }
  }

  getHeader = (obj: any) => {
    return obj.find((row: any) => row.TIPOREG==="1" );
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


}
